import Root from './Root';
import Route from './route';

export default {
  RenderProp: Root,
  mainRoute: Route,
};
